// base component
import { TitleComponent } from './title.component';

// components

export const TitleModule = angular.module('topbroker.pageTitle', [])
  .component('pageTitle', TitleComponent)
  .name;
